"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_SPRING_TENSION = 250;
exports.DEFAULT_SPRING = {
    tension: DEFAULT_SPRING_TENSION,
    friction: Math.sqrt(DEFAULT_SPRING_TENSION) * 2,
};
